import { ITypedReduxAction } from '../../../common/types/redux';
import { IMapMappedResponse } from '../../types/mappedResponse';

export enum EFetchMapDataActionType {
  Loading = 'fetchMapData/loading',
  Succeed = 'fetchMapData/succeed',
  Failed = 'fetchMapData/failed',
}

export interface IFetchMapDataSucceedParameters extends IMapMappedResponse {
  clean: boolean;
  tiles: YMaps.TTileNumber[];
  updateBounds: boolean;
}

export type TFetchMapDataLoading = ITypedReduxAction<EFetchMapDataActionType.Loading>;
export type TFetchMapDataSucceed = ITypedReduxAction<EFetchMapDataActionType.Succeed, IFetchMapDataSucceedParameters>;
export type TFetchMapDataFailed = ITypedReduxAction<EFetchMapDataActionType.Failed>;

export type TFetchMapDataActions = TFetchMapDataLoading | TFetchMapDataSucceed | TFetchMapDataFailed;
